import React from 'react';
import {useSelector} from "react-redux";

import NoActiveOrders from "../OrdersList/NoActiveOrders/NoActiveOrders";
import OrderItem from "../OrdersList/OrderItem/OrderItem";

const ActiveCleaningRequestsCustomer = ({handleDeleteOrder}) => {
    const {activeCleaningRequestsByCurrentUser} = useSelector(state => state.cleaningRequests);

    return (
        <div>
            {activeCleaningRequestsByCurrentUser?.length === 0 ?
                <NoActiveOrders/> :
                <>
                    {
                        activeCleaningRequestsByCurrentUser?.map((order, index) =>
                            <OrderItem
                                handleDeleteOrder={handleDeleteOrder}
                                key={index}
                                order={order}
                                type={'active'}
                            />)
                    }
                </>}
        </div>
    );
};

export default ActiveCleaningRequestsCustomer;
